import React, { useMemo } from 'react';
import { View, Text } from 'react-native';
import PropTypes from 'prop-types';
import { Checkbox, Hr } from 'LocalGluons';
import { t } from 'Locale';

import ChannelFavoriteList from '../ChannelFavoriteList';

import defaultStyles from './ChannelFavoriteFilterList.jss';

const ChannelFavoriteFilterList = ({
    channelIds,
    channelMap,
    orderedFavoriteList,
    setOrderedFavoriteList,
    query
}) => {
    // Memoize internal representation of channels
    const { channels, favoritesCount } = useMemo(() => {
        const channelResult = {
            channels: [],
            favoritesCount: 0
        };

        if (channelIds.length === 0) {
            return channelResult;
        }

        return channelIds.reduce((result, rawChannelId) => {
            const channelId = Number(rawChannelId);
            const channel = channelMap[channelId];
            if ((channel && !query) || (channel && channel.name.toLowerCase().startsWith(query))) {
                const favorite = orderedFavoriteList.indexOf(channelId) !== -1;
                result.channels.push({
                    ...channel,
                    channelId,
                    favorite
                });

                // Counts the number of favorites channels
                if (favorite) {
                    result.favoritesCount++;
                }
            }

            return result;
        }, channelResult);
    }, [orderedFavoriteList, channelIds, query]);

    return (
        <>
            <View style={defaultStyles.selectAllWrapper}>
                <Checkbox
                    onPress={(value) => {
                        if (channels.length > 0) {
                            const filteredChannelIds = channels.map((ch) => ch.channelId);
                            const newOrderedFavoriteList = value
                                ? // Add all channel ids from current category to favorites
                                  [...orderedFavoriteList, ...filteredChannelIds]
                                : orderedFavoriteList.filter(
                                      (chId) => filteredChannelIds.indexOf(chId) === -1
                                  );
                            setOrderedFavoriteList(newOrderedFavoriteList);
                        }
                    }}
                    checked={favoritesCount !== 0 && favoritesCount === channels.length}
                    style={defaultStyles.selectAllCheckbox}
                />
                <Text style={defaultStyles.selectAllText}>{t('RECORDINGS.SELECT_ALL')}</Text>
            </View>
            <Hr style={defaultStyles.checkboxHr} />
            <ChannelFavoriteList
                data={channels}
                onItemPress={({ channelId, favorite }) => {
                    const newOrderedFavoriteList = favorite
                        ? // If it is favorite, filter out if already there
                          orderedFavoriteList.filter((chId) => chId !== channelId)
                        : // else concat channel Id
                          [...orderedFavoriteList, channelId];
                    setOrderedFavoriteList(newOrderedFavoriteList);
                }}
            />
        </>
    );
};

ChannelFavoriteFilterList.defaultProps = {
    query: ''
};

ChannelFavoriteFilterList.propTypes = {
    channelIds: PropTypes.arrayOf(PropTypes.number).isRequired,
    channelMap: PropTypes.shape({}).isRequired,
    orderedFavoriteList: PropTypes.arrayOf(PropTypes.number).isRequired,
    setOrderedFavoriteList: PropTypes.func.isRequired,
    query: PropTypes.string
};

export { ChannelFavoriteFilterList };
